<template>
  <a v-if='props.url' :href='props.url' target="_blank" rel="noopener noreferrer">
    Read more
  </a>
  <router-link v-else-if='props.item?.url' :to='pathName(props.item.url)'>
    Read more
  </router-link>
</template>

<script setup>
import { pathName } from '@/utils'

const props = defineProps({
  item: {
    type: Object,
    required: false,
    default: {}
  },
  url: {
    type: String,
  }
});
</script>

<style scoped>
a {
  /*border: 1px solid rgba(255,255,255,0.025);*/
  padding: 1rem 2rem;
  margin-left: -0.25rem;
  display: inline-block;
  width: fit-content;
  border-radius: 10rem;
  /*backdrop-filter: blur(0.4rem);*/
  background-color: rgba(26, 26, 26, 1);
  transition: background-color 0.3s ease-in-out, transform 0.1s ease-in-out;
}

a:hover {
  cursor: pointer;
  background-color: rgba(66, 66, 66, 1);
}

a:active {
  transform: scale(0.97);
}
</style>
